import React from 'react';

interface SolidBoxWindowConfirmationProps {
  isVisible: boolean;
  width: number;
  depth: number;
  onConfirm: () => void;
  onCancel: () => void;
  position: { x: number; y: number }; // Canvas position to place the button near
}

const SolidBoxWindowConfirmation: React.FC<SolidBoxWindowConfirmationProps> = ({
  isVisible,
  width,
  depth,
  onConfirm,
  onCancel,
  position
}) => {
  if (!isVisible) return null;

  return (
    <div
      className="fixed z-50 pointer-events-none"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        transform: 'translate(-50%, -120%)'
      }}
    >
      <div className="pointer-events-auto bg-white rounded-lg shadow-2xl border-2 border-blue-500 p-4 min-w-[250px]">
        {/* Measurements Display */}
        <div className="mb-3 space-y-1">
          <div className="flex justify-between items-center text-sm">
            <span className="text-gray-600">Width:</span>
            <span className="font-semibold text-blue-600">{Math.round(width)} cm</span>
          </div>
          <div className="flex justify-between items-center text-sm">
            <span className="text-gray-600">Projection:</span>
            <span className="font-semibold text-green-600">{Math.round(depth)} cm</span>
          </div>
        </div>

        {/* Instruction */}
        <p className="text-xs text-gray-500 mb-3 text-center">
          Drag handles to adjust size
        </p>

        {/* Action Buttons */}
        <div className="flex gap-2">
          <button
            onClick={onCancel}
            className="flex-1 px-3 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-3 py-2 text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 rounded-md transition-colors shadow-md"
          >
            ✓ Confirm
          </button>
        </div>
      </div>

      {/* Pointer arrow */}
      <div 
        className="absolute left-1/2 bottom-0 transform -translate-x-1/2 translate-y-full"
        style={{
          width: 0,
          height: 0,
          borderLeft: '8px solid transparent',
          borderRight: '8px solid transparent',
          borderTop: '8px solid #3b82f6'
        }}
      />
    </div>
  );
};

export default SolidBoxWindowConfirmation;
